export const getColumnKey = (column) => column.key ?? column.dataIndex;

export const filterHiddenColumns = (columns, hiddenKeySet) => {
  if (!hiddenKeySet?.size) return columns;
  return columns.filter((column) => !hiddenKeySet.has(getColumnKey(column)));
};

export const columnsToOptions = (columns) => columns
  .filter((column) => !!column.title)
  .map((column) => ({ label: column.title, value: getColumnKey(column) }));

// A column definition is the static antd column (key, title, dataIndex, width, align)
// plus an optional `showIf(flags)` gate and a `label` for columns whose title is empty.
export const getActiveColumns = (columnDefinitions, flags = {}) => (
  columnDefinitions.filter((column) => !column.showIf || column.showIf(flags))
);

export const getColumnOptions = (columnDefinitions, flags) => (
  getActiveColumns(columnDefinitions, flags)
    .map(({ key, title, label }) => ({ label: label ?? title, value: key }))
);

// Merges each table's runtime column props (render) by key and drops columns the user hid.
export const buildColumns = ({
  columnDefinitions,
  flags,
  columnProps,
  hiddenKeySet,
}) => filterHiddenColumns(
  getActiveColumns(columnDefinitions, flags).map(({ showIf, label, ...column }) => ({
    ...column,
    ...columnProps[column.key],
  })),
  hiddenKeySet,
);
